import { ApiError, api } from "./api";

export interface PackInfo {
  name: string;
  title: string;
  sticker_count: number;
  cover_sticker_id: string | null;
}

export interface PackStickerItem {
  sticker_id: string; // custom emoji id
  emoji: string;
  position: number;
}

export interface PackDetailData {
  name: string;
  title: string;
  link: string;
  sticker_count: number;
  cover_sticker_id: string | null;
  stickers: PackStickerItem[];
}

const enc = encodeURIComponent;

export const packApi = {
  list: (fresh = false) =>
    api.get<{ packs: PackInfo[] }>(`/api/packs${fresh ? "?fresh=1" : ""}`).then((r) => r.packs),
  detail: (name: string, fresh = false) =>
    api.get<PackDetailData>(`/api/packs/${enc(name)}/stickers${fresh ? "?fresh=1" : ""}`),
  move: (name: string, stickerId: string, position: number) =>
    api.post<{ ok: boolean }>(`/api/packs/${enc(name)}/stickers/${enc(stickerId)}/move`, { position }),
  removeSticker: (name: string, stickerId: string) =>
    api.del<{ ok: boolean }>(`/api/packs/${enc(name)}/stickers/${enc(stickerId)}`),
  setEmoji: (name: string, stickerId: string, emoji: string) =>
    api.post<{ ok: boolean; emoji: string }>(`/api/packs/${enc(name)}/stickers/${enc(stickerId)}/emoji`, { emoji }),
  setCover: (name: string, stickerId: string) =>
    api.post<{ ok: boolean }>(`/api/packs/${enc(name)}/cover`, { sticker_id: stickerId }),
  rename: (name: string, title: string) =>
    api.post<{ ok: boolean; title: string }>(`/api/packs/${enc(name)}/rename`, { title }),
  remove: (name: string) => api.del<{ ok: boolean }>(`/api/packs/${enc(name)}`),
};

export function packLink(name: string): string {
  return `https://t.me/addemoji/${name}`;
}

export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    /* fall back below */
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(ta);
  }
}

export function haptic(kind: "light" | "medium" | "select" = "light"): void {
  try {
    const h = (window as unknown as { Telegram?: { WebApp?: { HapticFeedback?: Record<string, (s?: string) => void> } } })
      .Telegram?.WebApp?.HapticFeedback;
    if (!h) return;
    if (kind === "select") h.selectionChanged?.();
    else h.impactOccurred?.(kind);
  } catch {
    /* haptics are decoration only */
  }
}

/** The pack no longer exists on Telegram (e.g. it was deleted in the official @Stickers bot). */
export function isGone(err: unknown): boolean {
  if (err instanceof ApiError && err.status === 410) return true;
  return err instanceof Error && /STICKERSET_INVALID|STICKERSET_NOT_FOUND/i.test(err.message);
}

export function errorText(err: unknown, fallback = "حدث خطأ"): string {
  return err instanceof Error && err.message ? err.message : fallback;
}
